import InlineForm from "./inline-form";

export const schema = {
    giftGiver: {
        name: "Gift Giver",
        type: "text",
        placeholder: "Enter Name",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    dateRecieved: {
        name: "Date Recieved",
        type: "date",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    natureOfGift: {
        name: "Nature & Value of gift",
        type: "text",
        placeholder: "Enter Nature or Value of Gift",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    licenseeAcknowledgement: {
        name: "Licensee acknowledgement",
        type: "text",
        placeholder: "Enter Licesnsee Acknowledgement",
        style: {
            minWidth: "20ch",
        },
    },
    compliesWith: {
        name: "Complies with 53F(2)(d) $60",
        type: "text",
        placeholder: "Enter Complies with",
        style: {
            minWidth: "20ch",
        },
    },
};

const SG9GiftsAndBenefitsRegister = ({ formType, formTitle }) => {
    return <InlineForm schema={schema} formTitle={formTitle} formType={formType} />
};

export default SG9GiftsAndBenefitsRegister;
